<template>
      <navbar-vac v-if="$route.name != 'Inventory' && $route.name != 'PageNotFound'"/>
      <navbar-inventory v-if="$route.name == 'Inventory'"/>
    <main class="main">
        <router-view/>
    </main>
    <footer-vac v-if="$route.name != 'PageNotFound' && $route.name != 'Request' && $route.name != 'RequestCar'"/>
</template>



<script>
import NavbarVac from '@/components/NavbarVac.vue'
import FooterVac from '@/components/FooterVac.vue'
import NavbarInventory from '@/components/NavbarInventory.vue'
export default{

  components: {
    NavbarVac,
    NavbarInventory,
    FooterVac
  },

}

</script>



<style lang="scss">
@import '@/assets/scss/breakpoints.scss';


#app{
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.main{
  flex: 1 1 auto;
  margin-top: 80px;

  @include breakpoints(md){
        margin-top: 65px;
    }
    @include breakpoints(sm){
        margin-top: 55px;
    }
}
</style>
